import { useEffect, useState } from "react";
import { map, upperFirst } from "lodash";
import { getLocateDate } from "../../../utils/format-date-time.utils";
import Button from "../../common/Button";
import { useNavigate } from "react-router-dom";
import OrganisationsService from "../../../services/organisation.service";
import { TOrganisation } from "@answerr/types";

const Organisations = () => {
  const [organisations, setOrganisations] = useState<TOrganisation[]>([]);
  const navigate = useNavigate();

  const getOrganisations = async () => {
    try {
      const response = await OrganisationsService.getOrganisations();
      if (response.data.data && response.data.data.organisations) {
        setOrganisations(response.data.data.organisations);
      } else {
        console.log('Error: ', response.data.message);
      }
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  useEffect(() => {
    getOrganisations();
  }, []);

  return (
    <div className="overflow-y-auto w-full p-5">
      <div className="flex justify-between items-center mb-8">
        <h3 className='font-normal text-[40px]'>Organisations</h3>
        <div><Button classes="bg-[#333] text-white" onClick={() => navigate('/organisations/create')}>Create Organisation</Button></div>
      </div>
      <div className="overflow-x-auto p-5 rounded-2xl shadow-[0_0_8px_#cbcbcb]">
        <table className="text-[14px] bg-white min-w-full">
          <thead className="text-left">
            <tr className="text-[#616161]">
              <th className="p-3 min-w-[100px]">Organisation Name</th>
              <th className="p-3 min-w-[100px]">Primary Domain</th>
              <th className="p-3 min-w-[100px]">No. of Users</th>
              <th className="p-3 min-w-[100px]">From Date</th>
              <th className="p-3 min-w-[100px]">To Date</th>
              {/* <th className="p-3 min-w-[100px]">Input Tokens</th>
              <th className="p-3 min-w-[100px]">Output Tokens</th> */}
              <th className="p-3 min-w-[100px]">Email</th>
              <th className="p-3 min-w-[100px]">Status</th>
              <th className="p-3 min-w-[100px]">Created At</th>
              <th className="p-3 min-w-[100px]">Users</th>
              <th className="p-3 min-w-[100px]"></th>
            </tr>
          </thead>
          <tbody className="text-[#333] font-regular">
            {map(organisations, (organisation) => (
              <tr className="static rounded-lg border-b-8 border-white last:border-none" key={organisation._id}>
                <td className="px-3 py-5 first:font-semibold bg-[#fcfcfc]">{organisation?.organisationName}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{organisation?.primaryDomain}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{organisation?.numberOfCustomers}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{new Date(organisation?.fromDate).toLocaleString()}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{new Date(organisation?.toDate).toLocaleString()}</td>
                {/* <td className="px-3 py-5 bg-[#fcfcfc]">{organisation?.inputTokens}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{organisation?.outputTokens}</td> */}
                <td className="px-3 py-5 bg-[#fcfcfc]">{organisation?.email}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">
                  {upperFirst(organisation?.status)}
                </td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{organisation?.createdAt && getLocateDate(organisation?.createdAt.toString())}</td>
                <td className="px-3 py-5 bg-[#fcfcfc] cursor-pointer" onClick={() => navigate(`/organisations/${organisation._id}/users`)}>
                  <span className="font-bold">View</span>
                </td>
                <td className="px-3 py-5 bg-[#fcfcfc] cursor-pointer" onClick={() => navigate(`/organisations/update/${organisation._id}`)}>
                  <span className="font-bold">View Details</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Organisations;